import axios from "axios";
import { BN_APP } from "../../../constants/constant";
import { getAccessToken } from "../../../utils/okta-config";

export const getSuccessfulTransactions = async (userData, status, filters = {}) => {
  try {
    // Construct the UserDetailsDTO object from userData
    const userDetails = {
      userId: userData.userID,
      userRole: userData.userRole,
      businessRole: userData.authorities || [],
    };

    // Construct the request body with filters
    const requestBody = {
      userDetails,
      status,
      pageType: "SUCCESSFUL_TRANSACTIONS",
      limit: filters.limit || 500,
      offset: filters.offset || 0,
      sortBy: filters.sortBy || "billingDate",
      sortOrder: filters.sortOrder || "DESC",
      startDate: filters.startDate || null,
      endDate: filters.endDate || null,
      dealerNumber: filters.dealerNumber || null,
      dealerCountry: filters.dealerCountry || null,
      dealerUnit: filters.dealerUnit || null,
      source: filters.source || null,
    };

    const response = await axios.post(`${BN_APP}/transaction/getTransactions`, requestBody, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`, // Ensure getAccessToken() returns a valid token
        "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT, // Ensure this is set correctly
        "Content-Type": "application/json", // Set content type to JSON
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
